// src/components/GridView/GridViewSkeleton.tsx

const SKEL_DATA_COLS = 8;
const SKEL_ROWS = 20;
const SKEL_TITLE_WIDTHS = [
  140, 110, 160, 100, 130, 115, 150, 120, 95, 145, 105, 135, 155, 108, 125, 142, 98, 165, 112, 138,
];

export function GridViewSkeleton()
{
  return (
    <div className="gridview-container">
      <div className="gridview-sk">
        {/* ── Header row ── */}
        <div className="gridview-sk-header">
          {/* Row-number corner */}
          <div className="gridview-sk-rownum gridview-sk-header-cell" />
          {/* Title column header */}
          <div className="gridview-sk-title-col gridview-sk-header-cell">
            <div className="gridview-sk-bar animate-pulse" style={{ width: 90 }} />
          </div>
          {/* Data column headers */}
          {Array.from({ length: SKEL_DATA_COLS }).map((_, i) => (
            <div key={i} className="gridview-sk-data-col gridview-sk-header-cell">
              <div className="gridview-sk-bar animate-pulse" style={{ width: 70 }} />
            </div>
          ))}
        </div>

        {/* ── Data rows ── */}
        {Array.from({ length: SKEL_ROWS }).map((_, i) => (
          <div key={i} className="gridview-sk-row">
            {/* Row number */}
            <div className="gridview-sk-rownum gridview-sk-data-cell">
              <div className="gridview-sk-bar animate-pulse" style={{ width: 22 }} />
            </div>
            {/* Title cell: icon + text bar */}
            <div className="gridview-sk-title-col gridview-sk-data-cell">
              <div className="gridview-sk-icon animate-pulse" />
              <div
                className="gridview-sk-bar animate-pulse"
                style={{ width: SKEL_TITLE_WIDTHS[i % SKEL_TITLE_WIDTHS.length] }}
              />
            </div>
            {/* Empty data cells — borders only */}
            {Array.from({ length: SKEL_DATA_COLS }).map((_, j) => (
              <div key={j} className="gridview-sk-data-col gridview-sk-data-cell" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
